import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function TaskAltIcon(props: IconProps) {
    return <Icon {...props} iconKey={"task_alt"}/>
}
